import React from "react";
import { useState,useEffect } from "react";
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
 import Loading from './Loading';
import './classes/ViewSaadminDashboard.css';
import './classes/Modal.css';

function ViewSaadminDashboard  ({userLoggedInRoles})  {
    const [isLoading, setIsLoading] = useState(false);
    const [showmetricsdata, setShowMetrics] = useState(true);
    const [hidemetricsdata, setHideMetrics] = useState(false);
    const [metricsInputValue, setMetricsInputValue] = useState('Show Metrics');
    const [formData, setformData] = useState({
       date:''
    });
    const [reportlist, setReportList] = useState([]);
    const [abandonedlist, setAbandonedList] = useState([]);
    const [referrallist, setReferralList] = useState([]);
    const[showAbadonedCartModal, setShowAbandonedCartModal] = useState(false);
     const[showReferralModal, setShowReferralModal] = useState(false);
    const[abandonedModalName, setAbandonedModalName] = useState('');
     const[referralModalName, setReferralModalName] = useState('');
 const[reportname, setReportName] = useState('');
    const drupal_url = configData.DRUPAL_DOMAIN_URL;
  const handleChange = async (event) => {
    const { name, value } = event.target;
    setformData({date:value});
    try {
          setIsLoading(true);
          const response = await fetch(app_url+'report/dashboard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
         
              date:value
            }),
          });
      const data = await response.json();
          if(data.data.msg == "Success") {
            setReportList(data.data.result);
          }
      }catch (error) {
            console.error('Error fetching data:', error);
      } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
      }
    
  };
  const currentDate = new Date();
  const months = [];

  for (let i = 0; i < 12; i++) {
  const month = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
  months.push({
    value: month.toISOString().slice(0, 7), // YYYY-MM format
    label:  month.toISOString().slice(0, 7),
  });
}

  const app_url = configData.APP_URL;
    const showMetrics = async (e) => {
      e.preventDefault();
      try {
          setIsLoading(true);
          setMetricsInputValue('Loading...');
          const response = await fetch(app_url+'report/dashboard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
         
              formData:formData
            }),
          });
      const data = await response.json();
          if(data.data.msg == "Success") {
            setHideMetrics(true);
            setShowMetrics(false);
            setReportList(data.data.result);
            console.log(reportlist);
          }
      }catch (error) {
            console.error('Error fetching data:', error);
      } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
      }

  
}; 
const hideMetrics = async (e) => {
  setHideMetrics(false);
  setShowMetrics(true);
  setMetricsInputValue('Show Metrics');
}
 const handleAbandonedCart = async (report_name) => {
     
      try {
          setIsLoading(true);
          const response = await fetch(app_url+'report/getabandonedcart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name:report_name,
              formData:formData
            }),
          });
        const data = await response.json();
          if(data.data.msg == "Success") {
            
            setAbandonedList(data.data.result);
            setReportName(report_name);
            if(report_name == "new_apps") {
              setAbandonedModalName('Abandoned Carts - New Apps');
              setShowAbandonedCartModal(true);
            }
            if(report_name == "pre_apps") {
              setAbandonedModalName('Abandoned Carts - Pre Apps');
              setShowAbandonedCartModal(true);
            }
             if(report_name == "full_apps") {
              setAbandonedModalName('Abandoned Carts - Full Apps');
              setShowAbandonedCartModal(true);
            }
            console.log(reportlist);
          } 
      }catch (error) {
            console.error('Error fetching data:', error);
      } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
      }

  
}; 

const handleReferralApps = async (report_name) => {
     
      try {
          setIsLoading(true);
          const response = await fetch(app_url+'report/getreferralreport', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name:report_name,
              formData:formData
            }),
          });
        const data = await response.json();
          if(data.data.msg == "Success") {
            
            setReferralList(data.data.result);
            setReportName(report_name);
            if(report_name == "new_apps") {
              setReferralModalName('Referrals - New Apps');
              setShowReferralModal(true);
            }
            if(report_name == "paid_apps") {
              setReferralModalName('Referrals - Payments');
              setShowReferralModal(true);
            }
            
            console.log(reportlist);
          } 
      }catch (error) {
            console.error('Error fetching data:', error);
      } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
      }

  
}; 

 const handleModalClose = (modalname) => {
        if(modalname == 'abandonedcart') {
        setShowAbandonedCartModal(false); 
        }
  if(modalname == 'referralapps') {
        setShowReferralModal(false); 
        }
  
  
    };
    const handleExport = async (report_name) => {
  
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/abandonedreportexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:report_name,
              formData:formData
        }),
      });
      const data = await response.json();
     const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };

  const handleReferralExport = async (report_name) => {
  
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/referralreportexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:report_name,
              formData:formData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
        
    return (     
     <div className="dp-style">
      {isLoading && (
        <div className="loading-overlay">
          <img src={`${process.env.PUBLIC_URL}/images/ajax-loader.gif`} alt="loader" className='thankyou-loader' />
        </div>
      )}
      {showmetricsdata && (
        <><input type="button" id="show_metrics"  value={metricsInputValue} onClick={showMetrics}></input><br/><br/></>
      )}
        {hidemetricsdata && (
        
         <><input type="button" id="hide_metrics"  value="Hide Metrics" onClick={hideMetrics}></input><br/><br/>
        <div className="metrics_report" id="metrics_report">
          <form>
            <div style={{float:"left"}}>
              <label>Previous months  </label>&nbsp;&nbsp;
            </div>
            <div style={{float:"left"}}>
              <select onChange={handleChange} name="date">
                <option value="">None</option>
                {months.map((month, index) => (
                <option key={index} value={month.value}>
                  {month.label}
                </option>
                ))}
              </select>
            </div>
            <div style={{clear:"both"}}></div>
          </form>
          <div id="total_product" class="page-view-myorder">
            <div class="panel panel-default ">
            <div class="panel-heading" style={{ backgroundColor: '#fefefe' }}>
              <b>Month to Date Payments</b>
            
            </div>
            <div class="panel-body">
              <table class="table table-bordered table-striped"><tbody><tr><th>Product</th><th>Total</th></tr>
              {Object.keys(reportlist).length > 0 && Object.values(reportlist).map((value, index) => (
                <>
                {value.label == "Abandoned Carts - New Apps" ? (
                    <><tr><td>{value.label}<br/><span style={{ fontSize: '12px',fontWeight: 'normal' }}>*The user's information will not show if they have not entered their shipping or payment information.</span></td><td><a href onClick={() => handleAbandonedCart("new_apps")}>{value.value}</a></td></tr></>
                ) : value.label == "Abandoned Carts - Pre Apps" ? (
                  <><tr><td>{value.label}</td><td><a href onClick={() => handleAbandonedCart("pre_apps")}>{value.value}</a></td></tr></>
                ) : value.label == "Abandoned Carts - Full Apps" ? (
                  <><tr><td>{value.label}</td><td><a href onClick={() => handleAbandonedCart("full_apps")}>{value.value}</a></td></tr></>
                ) : value.label == "Referrals - New Apps" ? (
                  <><tr><td>{value.label}</td><td><a href onClick={() => handleReferralApps("new_apps")}>{value.value}</a></td></tr></>
                ) : value.label == "Referrals - Payments" ? (
                  <><tr><td>{value.label}</td><td><a href onClick={() => handleReferralApps("paid_apps")}>{value.value}</a></td></tr></>
                ) : (
                <><tr><td>{value.label}</td><td>{value.value}</td></tr></>
                )}
                </>
              ))}
              </tbody></table>
            </div>
            </div>
          </div>
        </div></>
        )}
        {showAbadonedCartModal && (
          <>
        <div id="myModal" class="modal abandonedcartmodal">
        
         
          <div class="modal-content">
            <div class="modal-header">
              <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('abandonedcart')}>&times;</span><input type="button" name="export" value="Export" className="export-button" onClick={() => handleExport(reportname)}></input>
              <h2>{abandonedModalName}</h2>
            </div>
            <div class="modal-body">
               <table>
                <tr><th>Name</th><th>Email</th><th>Salesperson</th><th>Product(s)</th><th>Cart Amount</th><th>Abandoned At</th></tr>
                {/* {Object.keys(abandonedlist).length > 0 && Object.values(abandonedlist).map((value, index) => ( */}
                {abandonedlist.length > 0 &&
                abandonedlist.map(value => (
                 
                  <><tr><td>{value.name}</td><td><a href={'/user/'+value.drupal_uid}>{value.email}</a></td><td>{value.salesperson}</td><td>{value.product}</td><td>${value.sale_amount}</td><td>{value.updated_at}</td></tr></>
                ))}
               </table>
            </div>
            
          </div>
        
        </div>
        </>
        )}
         {showReferralModal && (
          <>
        <div id="myModal" class="modal abandonedcartmodal">
        
         
          <div class="modal-content">
            <div class="modal-header">
              <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('referralapps')}>&times;</span><input type="button" name="export" value="Export" className="export-button" onClick={() => handleReferralExport(reportname)}></input>
              <h2>{referralModalName}</h2>
            </div>
            <div class="modal-body">
              {reportname == "new_apps" && (
                <>
               <table>
                <tr><th>Referee Name</th><th>Referee Email</th><th>Referee’s Salesperson</th><th>Referrer Name</th><th>Referrer Email</th><th>Referrer’s Salesperson</th><th>Date</th></tr>
                {Object.keys(referrallist).length > 0 && Object.values(referrallist).map((value, index) => (
                  <><tr><td>{value.name}</td><td><a href={'/user/'+value.drupal_uid}>{value.email}</a></td><td>{value.salesperson}</td><td>{value.referrer_name}</td><td><a href={'/user/'+value.referrer_drupal_uid}>{value.referrer_email}</a></td><td>{value.referer_salesperson}</td><td>{value.date}</td></tr></>
                     ))}
               </table>
               </>
              )}
               {reportname == "paid_apps" && (
                <>
               <table>
                <tr><th>Referee Name</th><th>Referee Email</th><th>Referee’s Salesperson</th><th>Referrer Name</th><th>Referrer Email</th><th>Product(s)</th><th>Purchased Amount</th><th>Shipping Amount</th><th>Purchased Date</th><th>Coupon Generated Date</th></tr>
                {Object.keys(referrallist).length > 0 && Object.values(referrallist).map((value, index) => (
                  <><tr><td>{value.name}</td><td><a href={'/user/'+value.drupal_uid}>{value.email}</a></td><td>{value.salesperson}</td><td>{value.referral_name}</td><td><a href={'/user/'+value.referral_drupal_uid}>{value.referral_email}</a></td><td>{value.product}</td><td>{value.total}</td><td>{value.ship_amount}</td>
                  <td>{value.updated_at}</td><td>{value.coupon_created}</td>
                  </tr></>
                     ))}
               </table>
               </>
              )}
            </div>
            
          </div>
        
        </div>
        </>
        )}
          <div className="row">
              <div className="col-md-4">
                <div className="panel panel-default">
                  <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                    <b>Agents, Athletes &amp; Scouts</b>
                  </div>
                  <div className="panel-body">
                    <ul className="fl-sub">
                      <li><a href="/add_athlete">Add Athlete</a></li> 
                      <li><a href="/admin/people/create">Add User</a></li>
                      <li><a href="/agents-directory">Agent Directory</a></li>
                      <li><a href="/admin/config/content/profile-approval">Approve/Deny Profile Changes</a></li>
                      
                      <li><a href="/pending_athletes">Athletes Looking for an Agent</a></li>  
                      <li><a href="/manage-agents">Manage Agents</a></li>      
                       
                        <li><a href="/saadmin/manage-agent-message">Manage Agents Message</a></li>      
                      
                      <li><a href="/manage-athletes">Manage Athletes</a></li> 
                      
                        <li><a href="/saadmin/manage-scout-message">Manage Scout Message</a></li>      
                       
                      
                      <li><a href="/manage-scouting-reports">Manage Scouting Reports</a></li> 						
                      <li><a href="/resource_library">Resource Library</a></li>
                      <li><a href="/admin/reports/agent_athlete_scout">Scout, Agent and Athlete Export</a></li>        
                      <li><a href="/scouts-directory">Scouts Directory</a></li>
                      <li><a href="/view/scouting-requests">View Scouting Requests</a></li>
				    </ul>
                  </div>
                </div>
                <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Course Control</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
					    <li><a href="/node/add/course">Add a New Course Page</a></li>
						
					    <li><a href="/admin/smww-commerce/coupon-create">Create New Coupon</a></li>
                        <li><a href="/admin/smww-commerce/discount-create">Create New Discount</a></li>
						<li><a href="/admin/smww-commerce/coupon-list">Edit Coupons</a></li>
						<li><a href="/admin/smww-commerce/product-list">Edit Courses Fees</a></li>
						<li><a href="/admin/smww-commerce/discount-list">Edit Discounts</a></li> 						
                        <li><a href="/admin/smww-commerce/product-edit/195">Edit Re-enrollment Fee</a></li>
                        <li><a href="/manage_seats_in_course">Manage Number of Seats on Course Pages</a></li>
						<li><a href="/course_code_key">View Course Code Key</a></li>
                  </ul>
                </div>
              </div>
              <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Apparel Store Control</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
					    <li><a href="/admin/smww-commerce/product-create">Add a New Product</a></li>
						<li><a href="/admin/smww-commerce/product-categories-list">Manage Categories</a></li>
            <li><a href="/apparel-order-list">Manage Orders</a></li>
                        <li><a href="/admin/smww-commerce/product-list">Manage Products</a></li>
						
						<li><a href="/apparel-order-status-log">Order Status Log</a></li>
                  </ul>
                </div>
              </div>
              </div>
		        <div className="col-md-4">
                     <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Conferences</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
                    <li><a href="/node/add/conferences">Add a New Conference Page</a></li>
                        <li><a href="/conference-registration">Conference Registration Report</a></li>                       
                        <li><a href="/admin/smww-commerce/product-list">Manage Conferences Prices</a></li>
						<li><a href="/manage-doc-talk-mentors">Manage DOC Talks</a></li>
                  </ul>
                </div>
              </div>
              <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Reports</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
                    <li><a href="/admin/reports/apps_by_country">Apps by Country Report</a></li>
                    
				    {/* <li><a href="/subscription/payment/cancelled">Cancelled Payments Report</a></li>  */}
                    {/* <li><a href="/admin/reports/instructor_pay">Instructor Pay Report</a></li> */}
                    <li><a href="/admin/reports/courses-payments">Payments Report</a></li>
					<li><a href="/admin/reports/sales_details_new">Payments Comparison Report</a></li>
                    <li><a href="/admin/reports/refererrer_bonus">Referrals Report</a></li>
                     {/* {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) &&
					              <li><a href="/admin/reports/weekly_sales_report">Sales &amp; Apps Report</a></li>
                     }										  */}
					<li><a href="/admin/reports/sales_report_by_product">Sales Report by Product</a></li>
          <li><a href="/admin/reports/event_log">Salesperson Activity Report</a></li>	
          <li><a href="/admin/reports/sales_report_by_sortflag">Sort Flags Sales Report</a></li>		
                    <li><a href="/admin/reports/sort_flag">Sort Flags Report</a></li>
                    
					<li><a href="/admin/reports/suspended_payment">Suspended Payments Report</a></li>
				    <li><a href="/user-advance-search">User Advanced Search Report</a></li>
            <li><a href="/admin/reports/attribution">User Attribution Report</a></li>
            
                  </ul>
                </div>
              </div>
               <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Store Control</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
                        <li><a href="/admin/smww-commerce/order-list">Manage Orders</a></li>
                  </ul>
                </div>
              </div>
               <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Blog &amp; News</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
					    <li><a href={"/node/add/blog"}>Add Blog Post</a></li>
              <li><a href={drupal_url+"/node/add/smww-news"}>Add News Post</a></li>
              <li><a href= {drupal_url+"/blog"}>Blog Home</a></li>
						<li><a href={"/manage-blog"}>Manage Blog Post</a></li>

						<li><a href={drupal_url+"/manage-news"}>Manage News</a></li>
						<li><a href="/page-editor">Page Editor</a></li>
						<li><a href="/node/add/visual-page">Create Visual Page</a></li>
						<li><a href="/manage-visual-pages">Manage Visual Pages</a></li>
						{userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && (
						<li><a href="/global-course-content">Global Course Content</a></li>
						)}
                  </ul>
                </div>
              </div>
          </div>
		      <div className="col-md-4">
            <div className="panel panel-default">
              <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                <b>Operations</b>
              </div>
              <div className="panel-body">
                <ul className="fl-sub">
                  <li><a href= {drupal_url+"/node/add"}>Add content</a></li>
                  <li><a href="/importer/application">Application Importer</a></li>
                  <li><a href="/admin/structure/taxonomy/sort_flags/add">Create Sort Flags</a></li>
                  <li><a href="/admin/reports/cuc_dates">Degree Dates</a></li>
                  <li><a href="/admin/structure/menu/manage/menu-top-menu">Edit Top Drop-Down Menu</a></li>
                  <li><a href="https://docs.google.com/document/d/1RxU-_jB2KfFs4jkhMcVFp5msbkEP1u2O-vSBX_nnF1Q/edit?usp=sharing">Instructions</a></li>
                  <li><a href="/admin/smww-commerce/countdown_timer">Manage Countdown Header</a></li>
                  <li><a href="/cuc/faq">Manage CUC FAQ</a></li>	
                  <li><a href="/manage-emails">Manage Emails</a></li>
                  <li><a href="/add-shipping-rates">Manage Flat Shipping Rates</a></li>
				  <li><a href="/admin/captcha_enable">Manage Form Captcha</a></li>
				  <li><a href="/manage-referrals">Manage Referrals</a></li>	
                  <li><a href="/sortflags">Manage Sort Flags</a></li>
                  <li><a href="/my_sales_tasks">My Tasks</a></li>
                  <li><a href="/draft-divvy">Run App Divvy For Draft</a></li>			     
                  <li><a href="/app-list">View All Applications</a></li>
						
                </ul>
              </div>
            </div>
            <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>People</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
                     
                     <li><a href="/admin/people/create">Add People</a></li>						
					 <li><a href={drupal_url+"/node/add/testimonial"}>Add Testimonial</a></li>
					 <li><a href={drupal_url+"/node/3455/webform-results"}>Alumni Contact Information</a></li>
                     <li><a href={drupal_url+"/manage-conference-speakers"}>Manage Conference Speakers</a></li>
					 <li><a href={drupal_url+"/manage-global-ambassadors"}>Manage Global Ambassadors</a></li>
              {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ? (
					      <li><a href="/manage/people">Manage People</a></li>  
              ) : (
                <li><a href="/saadmin-people">Manage People</a></li> 
              )
              }
                     <li><a href={drupal_url+"/manage-success-stories"}>Manage Success Stories</a></li>
                     <li><a href={drupal_url+"/manage-testimonial"}>Manage Testimonial</a></li>
                     <li><a href="/importer/rolodex">Professional Rolodex Importer</a></li>
                     
                  </ul>
                </div>
              </div>
			    </div>
      </div>
    </div>
    
    
     )}

export default ViewSaadminDashboard